import { render, staticRenderFns } from "./SourcesPanel.vue?vue&type=template&id=128b0472&scoped=true&"
import script from "./SourcesPanel.vue?vue&type=script&lang=js&"
export * from "./SourcesPanel.vue?vue&type=script&lang=js&"
import style0 from "./SourcesPanel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SourcesPanel.vue?vue&type=style&index=1&id=128b0472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b0472",
  null
  
)

export default component.exports